import { useMutation, useQueryClient } from '@tanstack/react-query'

import { updatePackage } from '@/api/pkg/pkgService'

import { QUERY_KEYS } from '../../../lib/queryKeys'
import { UpdateUserPkgPayload } from '../types/UpdateUserPkgPayload'
import { UserPkg } from '../types/UserPkg'

export const useUpdateUserPackage = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (payload: UpdateUserPkgPayload) => updatePackage(payload.packageId, payload.updateParam),
    onMutate: ({ packageId, updateParam }) => {
      queryClient.cancelQueries({ queryKey: [QUERY_KEYS.USER_PACKAGES] })
      const oldPkgs = queryClient.getQueryData([QUERY_KEYS.USER_PACKAGES])
      queryClient.setQueryData<UserPkg[]>([QUERY_KEYS.USER_PACKAGES], old =>
        old?.map(item => (item.id === packageId ? { ...item, ...updateParam } : item))
      )
      return { oldPkgs }
    },
    onSuccess: (_, payload) => {
      queryClient.refetchQueries({ queryKey: [QUERY_KEYS.PACKAGE_TAXES, payload.packageId] })
    },
    onError: (_error, _, context) => {
      if (context?.oldPkgs) {
        queryClient.setQueryData([QUERY_KEYS.USER_PACKAGES], context.oldPkgs)
      }
    },
  })
}
